module.exports = __webpack_public_path__ + "img/1F610.7fe6147c.svg";